var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"toggle",attrs:{"type":"checkbox","role":"switch"},domProps:{"checked":_vm.value ^ _vm.inverted},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }